<div class="linked-component-audit-table">
  <div class="row">
    <utils-bar [search]="true"
               (searchValueChanged)="applyFilter($event)"
               (searchValueSubmitted)="applyFilter($event)"
               (searchCleared)="clearSearch()">
    </utils-bar>

    <mat-paginator [length]="componentComponents?.length" [pageSize]="pageSize">
    </mat-paginator>
  </div>
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let row"> {{row.name}}</td>
    </ng-container>
    <ng-container matColumnDef="created_by">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Linked by</th>
      <td mat-cell *matCellDef="let row"> {{row.created_by}}</td>
    </ng-container>
    <ng-container matColumnDef="created_on">
      <th mat-header-cell mat-sort-header *matHeaderCellDef>Linked on</th>
      <td mat-cell *matCellDef="let row"> {{row.created_on | stringDate}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
</div>
